import { z } from "zod";

export const BaseConfigurationsOutputItemSchema = z.object({
    id: z.number(),
    label: z.string(),
});

export type BaseConfigurationsOutputItem = z.infer<typeof BaseConfigurationsOutputItemSchema>;

export const BaseConfigurationsOutputItemWithColorSchema = BaseConfigurationsOutputItemSchema.extend({
    color: z.string(),
});

export type BaseConfigurationsOutputItemWithColor = z.infer<typeof BaseConfigurationsOutputItemWithColorSchema>;